import {
  parseQuotationSummaryDTO,
  QuotationSummaryDTO
} from 'components/ordering/quotation/api/dtos/quotation-summary-dto.js'
import { QuotationRequest } from 'components/ordering/quotation/api/quotation-request.js'

export class SummarizeQuotations extends QuotationRequest<QuotationSummaryDTO, never> {
  path = 'quotation/summary/'

  override parseResponse = parseQuotationSummaryDTO
}
